/**
 * Types
 */

export const StepTypes = {
    SET_ACTIVE_PAGE: 'step/SET_ACTIVE_PAGE',
    RESET: 'step/RESET'
};

/**
 * Reducer
 */

const INITIAL_STATE = {
    activePage: 0
};

export function stepReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case StepTypes.RESET: {
            return { ...INITIAL_STATE };
        }
        case StepTypes.SET_ACTIVE_PAGE: {
            return {
                ...state,
                activePage: action.payload
            };
        }

        default:
            return state;
    }
}

/**
 * Actions
 */
export const Creators = {
    setActivePage: (activePage) => ({
        type: StepTypes.SET_PAGINA_ATIVA,
        payload: { activePage }
    }),
    reset: () => ({
        type: StepTypes.RESET
    })
};
